<template>
  <textarea
    :name="name"
    :placeholder="placeholder"
    :required="isRequired"
    :pattern="pattern"
    class="input"
    :class="[ isMini && 'input--mini']"
    :maxlength="maxlength"
    :value="value"
    @keypress="$event.target.classList.add('touched')"
    @keyup.enter="$emit('keyup', $event.target.value)"
    @input="$emit('input', $event.target.value)"
    @focus="$emit('focus')"
  />
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'text'
      },
      name: {
        type: String,
        default: null
      },
      pattern: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      maxlength: {
        type: String,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: null
      }
    }
  };
</script>

<style lang="scss">
  textarea {
    resize: vertical;
  }
</style>
